import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PatientCalendarComponent } from 'app/@components/patient-calendar/patient-calendar.component';
import { PatientsService } from 'app/@core/backend/common/services/CalorieFriend/patients.service';
import { Patient, PatientData } from 'app/@core/interfaces/common/CalorieFriend/patients';
import { PatientStore } from 'app/@core/stores/patient.store';
import { Subject } from 'rxjs';
import { filter, takeUntil, takeWhile } from 'rxjs/operators';

@Component({
  selector: 'ngx-program-overview',
  templateUrl: './program-overview.component.html',
  styleUrls: ['./program-overview.component.scss']
})
export class ProgramOverviewComponent implements OnInit {


  private readonly unsubscribe$: Subject<void> = new Subject<void>();
  public _isFitness: boolean = false;
  private _patientLoaded: boolean = false;


  constructor(private patientService: PatientData,
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private patientStore: PatientStore) { }

  patient: any;
  private loaded: boolean = false;

  @ViewChild('patientCalendarComponent') patientCalendarComponent: PatientCalendarComponent;

  ngOnInit(): void {
      this.patientStore
      .onPatientChanged()
      .pipe(
        takeWhile(() => !this._patientLoaded),
        takeUntil(this.unsubscribe$),
        filter((patient) => !!patient)
      )
      .subscribe((patient) => {
        this.patient = patient;
        this.unsubscribe$.unsubscribe();
      });
  }

}


